module.exports = __webpack_public_path__ + "img/upgrade-icon.da4bccf4.png";